import { render, staticRenderFns } from "./OnBoardingMatchMaking.vue?vue&type=template&id=5076683e&scoped=true&"
import script from "./OnBoardingMatchMaking.vue?vue&type=script&lang=js&"
export * from "./OnBoardingMatchMaking.vue?vue&type=script&lang=js&"
import style0 from "./OnBoardingMatchMaking.vue?vue&type=style&index=0&id=5076683e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5076683e",
  null
  
)

export default component.exports